<template>
  <div class="page_container">
    <div class="banner">
      <img src="../../assets/images/brandIncrease_banner.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon3">
        <i class="iconfont icon-pinpaizichanpingtai"></i>
      </div>
      <div class="breadcrumb_item">辅助功能&内容管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">买手图文管理</div>
    </div>

    <div class="input_box search flex-between">
      <van-field
        v-model="params.keyword"
        ref="input"
        placeholder="输入关键字查找→"
        @focus="handleFocus"
        @blur="handleBlur"
        @keyup.enter="handleSearch"
      />
      <div class="search_btn flex-rowr" @click="handleSearch">
        <i class="iconfont icon-sousuo"></i>
      </div>
    </div>
    <div class="input_tip flex-rowc">
      <span>请查看搜索结果</span>
      <div class="btn" @click="handleSearch">显示全部</div>
    </div>

    <div class="main_content">
      <div class="data_list" v-if="dataList.length > 0">
        <div class="item_card" v-for="item in dataList" :key="item.id">
          <div class="img_box" @click="handleDetail(item.id)">
            <!-- <img :src="item.img" alt="" /> -->
            <van-image
              width="100%"
              height="100%"
              fit="cover"
              :src="item.at_pic"
            />
          </div>
          <div class="block" @click="handleDetail(item.id)">
            <p>
              图文标题：<span>{{ item.at_topic }}</span>
            </p>
            <p>
              图文简介：<span>{{ item.at_intro }}</span>
            </p>
            <p>
              审核状态：<span>{{ item.checkstatestr }}</span>
            </p>
            <p>
              创建时间：<span>{{ item.createdate | formatDate }}</span>
            </p>
          </div>
          <!-- <div class="editBtn" @click="handleEdit(item.id)">管理商品信息→</div> -->
        </div>
      </div>
      <van-empty
        v-else-if="dataList.length == 0 && !loading"
        description="暂无数据"
      />
    </div>

    <div class="fixd_button_btm flex-rowl">
      <div class="item" @click="handleReturn">返回</div>
    </div>
  </div>
</template>

<script>
import { encryptstringadd } from "../../api/api";
import { getArticleList } from "../../api/article";
import { mapState } from "vuex";
export default {
  name: "articleList",
  data() {
    return {
      listTotal: 0,
      params: {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
        openid: "",
        checkstate: "",
        qyguid: ''
      },
      // 订单状态
      orderStateList: [
        { text: "全部", value: "" },
        { text: "待审核", value: "待审核" },
        { text: "已审核", value: "已审核" },
      ],
      loading: false,
      dataList: [],
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    this.params.qyguid = userInfo.qy ? userInfo.qy.qyguid : "";
    this.initData();
  },
  methods: {
    handleSearch() {
      this.params.pageindex = 1;
      this.initData();
    },

    initData() {
      let { params } = this;
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getArticleList(params).then((res) => {
        this.dataList = res.list;
        this.listTotal = res.total;
        // 加载状态结束
        this.loading = false;
        Toast.clear();
      });
    },

    // 筛选状态
    handleState(type, value) {
      if (type == 1) {
        this.params.checkstate = value;
      }
      this.initData();
    },

    // 物流详情
    handleDetail(id) {
      this.encryptstringadd("articleDetail", { id });
    },
    handleEdit(id) {
      this.encryptstringadd("articleEdit", { id });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    handleReturn() {
      this.$router.back();
    },

    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  padding-bottom: 420px;
  .input_box.search {
    padding: 0 30px 0 35px;
    margin-bottom: 30px;
    .search_btn {
      width: 60px;
    }
  }
  .input_tip {
    font-size: 14px;
    margin-bottom: 60px;
    color: #aaaaaa;
    .btn {
      margin-left: 30px;
      background: #6e5c86;
      color: #fff;
      padding: 0 15px;
      height: 40px;
      line-height: 40px;
      font-size: 12px;
      border-radius: 5px;
    }
  }
  .main_content {
    width: 650px;
    margin: 60px auto 100px;
    .data_list {
      // padding-bottom: 320px;
      .item_card {
        border: 2px solid #dedede;
        border-radius: 30px;
        padding: 45px 37px 87px;
        box-sizing: border-box;
        font-size: 22px;
        color: #404d6c;
        position: relative;
        margin-bottom: 55px;
        .block {
          margin-bottom: 30px;
        }
        .img_box {
          width: 250px;
          height: 250px;
          margin: 35px auto;
          background: #f8f8f8;
          overflow: hidden;
        }
        h1 {
          font-size: 30px;
          color: #404d6c;
          margin-bottom: 12px;
        }
        p {
          margin-bottom: 10px;
        }
        .editBtn {
          width: 200px;
          height: 50px;
          background: #6e5c86;
          border-radius: 25px;
          text-align: center;
          line-height: 50px;
          font-size: 20px;
          color: #fff;
          position: absolute;
          right: 20px;
          bottom: 20px;
        }
      }
    }
  }
}
</style>